import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import React, { useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import {  obtenerSolicitudEditarDev } from '../../../../redux/DuckUsuarioDeveloper/SolicitudesDevDuck';
import Swal from 'sweetalert2';

const EditarSolicitudesDevComponent = () => {

    const dispatch = useDispatch()

    const [folio, setFolio] = React.useState('')
    const [tipoSolicitud, setTipoSolicitud] = React.useState('')




    const buscarSolicitud = async () => {
        if (!tipoSolicitud || !folio) {
            Swal.fire('Error', 'Debes seleccionar un tipo de solicitud y escribir un folio', 'error')
            return;
        }
        let data = await dispatch(obtenerSolicitudEditarDev({folio, tipoSolicitud}))
        console.log('la data es ', data)
    }

    return (
        <div className="container">
            <div className='row'>
                <div className="col-6">
                    <div className="form-floating mb-2">
                        <select className="form-select" id="tipoSolicitud" value={tipoSolicitud} onChange={(e) => setTipoSolicitud(e.target.value)} >
                            <option value="">Selecciona tipo de solicitud</option>
                            <option value="fc_01_solicitudderegistro">fc_01_solicitudderegistro</option>
                            <option value="fc_05_solicitudusomarcaeimagen">fc_05_solicitudusomarcaeimagen</option>
                            <option value="fc_06_registrodemaguey">fc_06_registrodemaguey</option>
                            <option value="fc_08_solicitudrenvacioncertificados">fc_08_solicitudrenvacioncertificados</option>
                            <option value="fc_09_solicitudemicioncertificadonomexportacionyentregahologram">fc_09_solicitudemicioncertificadonomexportacionyentregahologram</option>
                            <option value="fc_30_notificaciontrasladodeproducto">fc_30_notificaciontrasladodeproducto</option>
                            <option value="fc_31_solicitudseguimiento">fc_31_solicitudseguimiento</option>
                            <option value="fc_33_solicitudenvasadonacional">fc_33_solicitudenvasadonacional</option>
                            <option value="fc_34_notificacionsuspencionyreactivacion">fc_34_notificacionsuspencionyreactivacion</option>
                            <option value="fc_35_notificaciondeserviciosvarios">fc_35_notificaciondeserviciosvarios</option>
                            <option value="fc_36_solicituddeactualizacion">fc_36_solicituddeactualizacion</option>
                            <option value="fc_40_solicituddeadquisiciondehologramas">fc_40_solicituddeadquisiciondehologramas</option>
                            <option value="fc_41_solicitudparabebidasconmezcal">fc_41_solicitudparabebidasconmezcal</option>
                        </select>
                        <label htmlFor="tipoSolicitud">Tipo de Solicitud</label>
                    </div>
                </div>
                <div className='col-5'>
                    <div className="form-floating mb-2">
                        <input type="text" min="0" className={`form-control `} id="floatingInput" value={folio} onChange={e => setFolio(e.target.value)} />
                        <label htmlFor='floatingInput'>Ingrese un Folio:</label>
                    </div>
                </div>
                <div className='col-1'>
                    <button onClick={() => buscarSolicitud()} className='btn btn-outline-success'>Buscar Folio</button>
                </div>
            </div>

        </div>
    );

};
export default EditarSolicitudesDevComponent